A page of events matching the specified criteria.

A maximum of 100 events can be returned in a single page.
Additional events can be queried using a pagination cursor.

The result list is returned in ascending stream date & time order.
It starts from the earliest known event if no pagination arguments are provided.
